module.exports = __webpack_public_path__ + "img/uk-pneumonia-male.689d1864.png";